module.exports = __webpack_public_path__ + "img/botella_black_4_1.693d5d2c.png";